"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Substituted user converter.
 *
 * @author Radek Beran
 */


var SubstitutedUserConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SubstitutedUserConverter, _DataObjectConverter_);

  function SubstitutedUserConverter() {
    _classCallCheck(this, SubstitutedUserConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SubstitutedUserConverter).apply(this, arguments));
  }

  return SubstitutedUserConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SubstitutedUserConverter = SubstitutedUserConverter;